import { SalesDespatchItemDetails } from './sales-despatch-item-details';
import { SalesInvoiceHeaderDeliveryItem } from './sales-invoice-header-delivery-item';
import { SalesInvoiceHeaderExtraItem } from './sales-invoice-header-extra-item';
import { SalesInvoiceStatusItem } from './sales-invoice-status-item';
import { SalesInvoiceValue } from './sales-invoice-value';

export interface SalesInvoiceHeaderDetails {
  id: string;
  invoiceNo: number;
  dateInvoiced: Date;
  createdBy: string;
  customerId: string;
  customerKey: string;
  customerName: string;
  customerAddressMultiLine: string;
  customerInvoiceRef: string;
  customerContactId: string;
  deliveryAddressId: string;
  deliveryAddressMultiLine: string;
  invoiceAddressId: string;
  invoiceAddressMultiLine: string;
  modeOfTransportId: string;
  deliveryTermId: string;
  portId: string;
  shipperSupplierId: string;
  invoiceStatusId: string;
  invoiceStatusDescription: string;
  paymentTermId: string;
  settlementTermId: string;
  currencyId: string;
  bankId: string;
  taxId: string;
  sellingCompanyId: string;
  paymentDueDate: Date;
  dateCreated: Date;
  vatRegNo: string;
  enableUpdatePriceButton: boolean;
  salesOrderHeaderIds: string[];
  deliveryAddresseeId: string;
  deliveryAddressee: string;
  invoiceAddresseeId: string;
  invoiceAddressee: string;
  chargeDelivery: boolean;
  customerPostcode: string;
  deliveryPostcode: string;
  customerCountryId: string;
  deliveryCountryId: string;

  salesDespatchItemDetails: SalesDespatchItemDetails[];
  salesInvoiceHeaderDeliveryItems: SalesInvoiceHeaderDeliveryItem[];
  salesInvoiceHeaderExtraItems: SalesInvoiceHeaderExtraItem[];
  salesInvoiceStatusItems: SalesInvoiceStatusItem[];
  salesInvoiceValues: SalesInvoiceValue[];
}
